module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/toner_f70647.png";